<template>
  <div v-if="care_vital_sign.care_has_vital_signs.length > 0">
    <p
      :class="[
        'm-0 text-thirteen upper-text',
        parseInt(item.description) >= 60 &&
          parseInt(item.description) <= 100 &&
          'color-green',
        parseInt(item.description) >= 101 &&
          parseInt(item.description) <= 139 &&
          'color-orange',
        parseInt(item.description) >= 41 &&
          parseInt(item.description) <= 59 &&
          'color-orange',
        parseInt(item.description) >= 140 &&
          parseInt(item.description) <= 40 &&
          'color-red',
      ]"
    >
      {{ item.description }}
      {{ item.abbreviation }}
    </p>
    <p class="mb-1 worksansr text-twelve upper-text">
      CADASTRADO POR: {{ item.user_name }}
    </p>
    <hr />
  </div>
</template>

<script>
export default {
  name: "Pulso",
  props: {
    care_vital_sign: Object,
    item: Object,
  },
};
</script>